<template>
  <div class="row">
  	<div class="card col-12" style="width: 18rem;">
	  	<div class="card-body mb-5 mt-3">
	  		<div v-bind:class="loading">
		      <div class="d-flex justify-content-center">
		        <div class="spinner-border m-5" role="status">
		          <span class="sr-only">Loading...</span>
		        </div>
		      </div>
		    </div>
		    <div v-bind:class="result">
		  		<div class="row justify-content-center">
		  			<div class="col-12 text-center my-3">
		  				<h5>Formulario de Datos</h5>
		  			</div>
		  			<div class="col-md-10">
						<ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
						  <li class="nav-item text-center w-md-25">
						    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">	Datos Personales
						    	<i :class="personales"></i>
						    </a>
						  </li>
						  <li class="nav-item text-center w-md-25">
						    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
						    	Datos Académicos
						    	<i :class="academicos"></i>
						    </a>
						  </li>
						  <li class="nav-item text-center w-md-25">
						    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">
						    	Datos Contacto
						    	<i :class="contacto"></i>
						    </a>
						  </li>
						</ul>
						<form v-on:submit.prevent="Comenzar_Presentar" class="tab-content" id="myTabContent" autocomplete="off">
						  <div class="tab-pane fade pt-4 show active" id="home" role="tabpanel" aria-labelledby="home-tab">
						  	<div class="row justify-content-center">
						  		<div class="form-group text-center col-md-3">
									<label for="matricula">Matricula</label>
									<input v-model="solicitud.matricula" type="text" class="form-control text-center" id="matricula">
								</div>
							</div>
							<div class="row justify-content-center">
								<div class="form-group text-center col-md-4">
									<label for="paterno">Apellido Paterno</label>
									<input v-model="solicitud.apellido_paterno" type="text" class="form-control text-center" id="paterno">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="materno">Apellido Materno</label>
									<input v-model="solicitud.apellido_materno" type="text" class="form-control text-center" id="materno">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="nombre">Nombre(s)</label>
									<input v-model="solicitud.nombre" type="text" class="form-control text-center" id="nombre">
								</div>
						  	</div>
						  	<div class="row justify-content-center">
						  		<div class="form-group text-center col-md-3">
									<label for="edad">Edad</label>
									<input v-model="solicitud.edad" type="number" class="text-center form-control" id="edad">
								</div>
								<div class="form-group text-center col-md-3">
									<label for="periodo">Periodo</label>
									<input disabled v-model="solicitud.periodo" type="text" class="form-control text-center" id="periodo">
								</div>
						  	</div>
						  </div>
						  <div class="tab-pane fade pt-4" id="profile" role="tabpanel" aria-labelledby="profile-tab">
						  	<div class="row justify-content-center">
								<div class="form-group text-center col-md-6">
									<label for="procedencia">Esc. Procedencia</label>
									<input v-model="solicitud.procedencia" type="text" class="form-control text-center" id="procedencia">
								</div>
							</div>
							<div class="row justify-content-center">
								<div class="form-group text-center col-md-4">
								    <label for="escolaridad">Escolaridad</label>
								    <select v-model="solicitud.escolaridad" class="form-control" id="escolaridad">
								      <option value="Preparatoria">Preparatoria</option>
								      <option value="Tecnica">Tecnica</option>
								      <option value"Licenciatura">Licenciatura</option>
								    </select>
								</div>
								<div class="form-group text-center col-md-4">
								    <label for="preparatoria">Preparatoria</label>
								    <select v-model="solicitud.preparatoria" class="form-control" id="preparatoria">
								      <option value="UANL">UANL</option>
								      <option value="Privada">Privada</option>
								    </select>
								</div>
						  	</div>
						  </div>
						  <div class="tab-pane fade pt-4" id="contact" role="tabpanel" aria-labelledby="contact-tab">
						  	<div class="row justify-content-center">
						  		<div class="form-group text-center col-md-4">
									<label for="colonia">Colonia</label>
									<input v-model="solicitud.colonia" type="text" class="form-control text-center" id="colonia">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="municipio">Municipio</label>
									<input v-model="solicitud.municipio" type="text" class="form-control text-center" id="municipio">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="estado">Estado</label>
									<input v-model="solicitud.estado" type="text" class="form-control text-center" id="estado">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="email">Email</label>
									<input v-model="solicitud.email" type="email" class="form-control text-center" id="email">
								</div>
								<div class="form-group text-center col-md-4">
									<label for="telefono">Teléfono</label>
									<input v-model="solicitud.telefono" type="text" class="form-control text-center" id="telefono">
								</div>
							</div>
							<div class="row mt-3 justify-content-center">
								<div class="col-md-6 text-center">
									<div class="form-check form-check-inline">
									  <label class="form-check-label">Foráneo</label>
									</div>
									<div class="form-check form-check-inline">
									  <input class="form-check-input" type="radio" name="foraneo" id="no_foraneo" v-model="solicitud.foraneo" value="0">
									  <label class="form-check-label" for="no_foraneo">No</label>
									</div>
									<div class="form-check form-check-inline">
									  <input class="form-check-input" type="radio" name="foraneo" id="si_foraneo" v-model="solicitud.foraneo" value="1">
									  <label class="form-check-label" for="si_foraneo">Si</label>
									</div>
								</div>
							</div>
							<div class="row mt-4 justify-content-center">
								<div class="col-md-6 text-center">
									<button type="submit" class="btn btn-block btn-primary"><i class="fas fa-user-clock"></i> Comenzar Exámen </button>
								</div>
							</div>
						  </div>
						</form>
		  			</div>	
		  		</div>
		  	</div>
	  	</div>
	</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      folio:'',
      folio_pago:'',
      solicitud:{
      	idsolicitud:null,		
		periodo:"",		
		matricula:"",		
		nombre:"",
		apellido_paterno:"",
		apellido_materno:"",
		edad:15,
		procedencia:"",
		escolaridad:"Preparatoria",
		preparatoria:"UANL",
		colonia	:"",
		municipio:"",
		estado:"",
		email:"",
		telefono:"",
		foraneo:0
      }
    }
  },
  methods:{
  	Comenzar_Presentar(){
  		if (!this.Validar()) {return;}
  		this.Cargando();
		this.$http.post('solicitudes/info/personal',{
			solicitud:this.solicitud
		})
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			if (respuestaJson.resp=='Excelente') {
			  this.$router.push({name:'Examenes'});
			}else{
				this.Listo();
			  swal("¡Ups!",respuestaJson.resp, "error");  
			}
		})
		.catch(error=>{
			this.Listo();
			swal("Favor de Intentar mas tarde", "Problemas para enviar la información", "error");
		});
  	},
  	Consultar(){
  		this.Cargando();
		this.$http.get('solicitudes/info/personal')
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			if (respuestaJson.resp=='Excelente') {
				this.Listo();
			  this.solicitud=respuestaJson.solicitud;
			}else{
				this.Sin_Nada();
			  swal("¡Ups!",respuestaJson.resp, "error");  
			}
		})
		.catch(error=>{
			this.Sin_Nada();
			swal("Favor de Intentar mas tarde", "Problemas para cargar la información", "error");
		});
  	},
  	Validar(){
  		var pasar = true;
  		if (this.solicitud.matricula.length==0) {
  			pasar=false;
  			swal("La matricula es obligatoria","", "error");  
  		}
  		else if (this.solicitud.nombre.length==0) {
  			pasar=false;
  			swal("El nombre es obligatorio","", "error");  
  		}
  		else if (this.solicitud.apellido_paterno.length==0) {
  			pasar=false;
  			swal("El apellido paterno es obligatorio","", "error");
  		}
  		else if (this.solicitud.apellido_materno.length==0) {
  			pasar=false;
  			swal("El apellido materno es obligatorio","", "error");  
  		}
  		else if (this.solicitud.edad.length==0) {
  			pasar=false;
  			swal("La edad es obligatoria","", "error");  
  		}
  		else if (this.solicitud.procedencia.length==0) {
  			pasar=false;
  			swal("La procedencia es obligatoria","", "error");  
  		}
  		else if (this.solicitud.colonia.length==0) {
  			pasar=false;
  			swal("La colonia es obligatoria","", "error");  
  		}
  		else if (this.solicitud.municipio.length==0) {
  			pasar=false;
  			swal("El municipio es obligatorio","", "error");  
  		}
  		else if (this.solicitud.estado.length==0) {
  			pasar=false;
  			swal("El estado es obligatorio","", "error");  
  		}
  		else if (this.solicitud.email.length==0) {
  			pasar=false;
  			swal("El email es obligatorio","", "error");  
  		}
  		else if (this.solicitud.telefono.length==0) {
  			pasar=false;
  			swal("El telefono es obligatorio","", "error");  
  		}
  		return pasar;
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	},
  	Sin_Nada(){
  		this.loading='d-none';
  	}
  },
  computed: {
	    personales: function() {
	    	var clase='fas fa-check-circle';
	    	if (this.solicitud.matricula.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.nombre.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.apellido_paterno.length==0) {
	  			clase='far fa-check-circle';  
	  		}
	  		else if (this.solicitud.apellido_materno.length==0) {
	  			clase='far fa-check-circle';  
	  		}
	  		else if (this.solicitud.edad.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		return clase;
	    },
	    academicos: function() {
	    	var clase='fas fa-check-circle';
	    	if (this.solicitud.procedencia.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		return clase;
	    },
	    contacto: function() {
	    	var clase='fas fa-check-circle';
	    	if (this.solicitud.colonia.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.municipio.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.estado.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.email.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		else if (this.solicitud.telefono.length==0) {
	  			clase='far fa-check-circle';
	  		}
	  		return clase;
	    }
	},
	mounted(){
		this.Consultar();
	}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Datos_Alumno.vue